import { render, staticRenderFns } from "./guarules.vue?vue&type=template&id=2c51bdec&scoped=true&"
import script from "./guarules.vue?vue&type=script&lang=js&"
export * from "./guarules.vue?vue&type=script&lang=js&"
import style0 from "./guarules.vue?vue&type=style&index=0&id=2c51bdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51bdec",
  null
  
)

export default component.exports